// The Energy vertical is served by the standalone energy-webapp (nginx
// routes /energy/* on the org subdomains to its dev server on :3001).
// flex2-webapp no longer mounts energyRoutes; instead this catch-all
// converts any SPA navigation into /energy/* (system picker, sidebar
// links, login default-route) into a full page load so the browser
// actually leaves this bundle and fetches energy-webapp's index.
//
// Loop guard: on hosts whose nginx does NOT route /energy to
// energy-webapp (e.g. personal dev instances), the reload lands right
// back here — detect the immediate re-entry and show a note instead of
// reloading forever.
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LAST_HANDOFF_KEY = "energyHandoffAt";

export default function EnergyHandoff() {
  const { pathname, search } = useLocation();
  const [looping, setLooping] = useState(false);

  useEffect(() => {
    const last = Number(sessionStorage.getItem(LAST_HANDOFF_KEY) || 0);
    if (Date.now() - last < 5000) {
      setLooping(true);
      return;
    }
    sessionStorage.setItem(LAST_HANDOFF_KEY, String(Date.now()));
    window.location.replace(pathname + search);
  }, [pathname, search]);

  if (!looping) return null;
  return (
    <div style={{ padding: 40, fontFamily: "sans-serif" }}>
      The Energy portal is served by energy-webapp, but this host&apos;s
      nginx isn&apos;t routing <code>/energy</code> to it — see
      /etc/nginx/sites-enabled/liftconnectpro.dev for the reference block.
    </div>
  );
}
